module.exports = __webpack_public_path__ + "fonts/manrope-bold.35815d10.woff";